<script>
import cTable from "@/base/common/index.vue";
import {buildApi} from "@/libs/api.request";
import axios from "axios";
import {getWarehouse} from "@/api/storage/warehouse";

export default {
  name: "index",
  components: {cTable},
  data() {
    return {
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({row, close}) {
              let data = this.handleFilterData({
                id: row.id,
                history: this.list,
              });
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 1200,
              styles: {
                top: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              'from_country': [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              'target_country': [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],

              'price': [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            {
              title: 24,
              min_fees: 8,
              currency: 8,
              from_country: 8,
              target_country: 8,
              city_code: 8,
              start_date: 8,
              expired_date: 8,
              service_code: 8,
              transport_channel: 8,
              price: 8,
              unit_rule: 8,
              fee_type: 8,
            },
          ],
          fields: [
            {
              key: "title",
              name: () => this.$tz("方案名称"),
              placeholder() {
                return this.$tz("方案名称");
              },
              component: "Input",
            },{
              key: "min_fees",
              name: () => '最低消费',
              placeholder() {
                return this.$tz("请输入最低消费");
              },
              component: "Input",
              default: '0.00'
            },{
              name: () => '币种',
              key: "currency",
              placeholder() {
                return this.$tz('请选择') + '币种';
              },
              minWidth: 60,
              component: "Select",
              options: [],
              optionsFn: "getCurrency",
              optionsKey: "",
              bind: {
                align: "left"
              },
            }, {
              key: "from_country",
              name: () => '启运国家',
              placeholder() {
                return this.$tz('请选择') + this.$tz('启运国家');
              },
              component: "Select",
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
            },
            {
              key: "target_country",
              name: () => '目的国家',
              placeholder() {
                return '请选择目的国家';
              },
              component: "Select",
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
              methods: {
                "on-change"({ row, fields }) {
                  if (row.target_country) {
                    axios.get('/common/getMatchedCountryCityCode?countryCode=' + row.target_country).then(r => {
                      fields.map(v => {
                        if (v.key === 'city_code') {
                          v.options = r.data.payload
                        }
                      })
                    })
                  }

                }
              }
            },
            {
              key: "city_code",
              name: () => '城市代码',
              placeholder() {
                return '请选择城市代码';
              },
              component: "Select",
              options: this.$store.state.app.matchedCityCode,
              bind: {
                multiple: true
              }
            }, {
              name: () => '生效时间',
              key: "start_date",
              minWidth: 90,
              component: "DatePicker",
              placeholder() {
                return '请选择出库生效时间';
              },
              disabledDate: true,
            }, {
              name: () => '截至时间',
              key: "expired_date",
              minWidth: 90,
              component: "DatePicker",
              placeholder() {
                return '请选择出库截至时间';
              },
              disabledDate: true,
            }, {
              key: "service_code",
              name: () => '服务类型',
              placeholder() {
                return '请选择服务类型';
              },
              component: "Select",
              options: [],
              optionsFn: "getCommon",
              optionsKey: "",
              apiData: {
                apiType: 'service_code'
              },
              bind: {
                multiple: true
              }
            }, {
              key: "transport_channel",
              name: () => '运输方式',
              placeholder() {
                return '请选择运输方式';
              },
              component: "Select",
              options: [],
              optionsFn: "method",
              optionsKey: "",
              default: "",
              bind: {
                multiple: true
              },
            }, {
              name: () => '计费类型',
              key: "unit_rule",
              minWidth: 60,
              placeholder() {
                return '请选择计费类型';
              },
              component: "Select",
              options: [],
              optionsFn: "getCommon",
              optionsKey: "",
              bind: {
                align: "left"
              },
              apiData: {
                apiType: "chargingType"
              }
            }, {
              name: () => '价格',
              key: "price",
              minWidth: 60,
              component: "Input",
              placeholder() {
                return '请选择计费单价';
              },
              bind: {
                type: "number"
              }
            }, {
              name: () => '费用名称',
              key: "fee_type",
              minWidth: 60,
              placeholder() {
                return '请选择计费类型';
              },
              component: "Select",
              options: [{
                label: '派送费',
                value: 'DeliverFee'
              }, {
                label: '理货费',
                value: 'TallyFee'
              }, {
                label: '上架费',
                value: 'ListingFee'
              }, {
                label: '报关费',
                value: 'CustomsFees'
              }, {
                label: '转运费',
                value: 'TransferFreight'
              }],
            }
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$tz("请选择,日期,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "COST_DELIVERY_RULE_DATA_TYPE",
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            disabledDate: true,

            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            disabledDate: true,

            bind: {
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "fromCountry",
            placeholder() {
              return this.$tz("请选择,启运国家");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: "",
          },
          {
            key: "targetCountry",
            placeholder() {
              return this.$tz("请选择,目的国家");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: "",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      methods: {
        ...buildApi({
          get: ['/api/costing-deliver/index&list',],
          post: ['/api/costing-deliver/save', name + '/api/costing-deliver/delete/:id&del']
        })
      },
      fields: [
        {
          name: () => this.$tz("报价名称"),
          key: "title",
          width: 420,
        }, {
          name: () => this.$tz("起运地"),
          key: "from_country",
          width: 110,
        }, {
          name: () => this.$tz("目的港"),
          key: "target_country",
          width: 110,
        }, {
          name: () => this.$tz("城市代码"),
          key: "city_code",
          width: 330,
          render(h, {row, index}) {
            let collections = row['city_code']
            return h('div', {}, collections.map(v => {
              return h('VxeButton', {props: {status: 'primary', size: 'mini'}}, v)
            }))
          }
        }, {
          name: () => this.$tz("服务类型"),
          key: "service_code",
          width: 330,
          render(h, {row, index}) {
            let collections = row['service_code']
            return h('div', {}, collections.map(v => {
              return h('VxeButton', {props: {status: 'primary', size: 'mini'}}, v)
            }))
          }
        }, {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          width: 190,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          fixed: "right",
          list: [
            {
              name: this.$tz("编辑"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$tz("删除"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
            },
          ],
          methods: {
            update({row}) {
              this.getModal("add").open(row, function () {
                axios.get('/common/getMatchedCountryCityCode?countryCode=' + row.target_country).then(r => {
                  if (r.data.payload.length > 0) {
                    this.$store.commit('updateMatchedCityCode', r.data.payload)
                  }

                })
                this.setTitle(this.$tz("编辑"));
              });
            },
            delete({row}) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {id: row.id},
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    }
  }
}
</script>

<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<style scoped>

</style>
